import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { useAuthGuard } from "@/hooks/useAuthGuard";

export function Shell() {
  const { isLoading } = useAuthGuard();
  if (isLoading) return null;
  return (
    <div className="flex h-screen w-screen bg-background text-foreground">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
